import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PersoneOffDay_Interface } from 'src/app/Interface/PersoneOffDay_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PersonOffDayService {

  constructor(private http: HttpClient) { }


  GetOffday(Token: String,
    PeriodDate:number,
    status:number,
    fullname:String,
    StartSearchDate:String,
    EndSearchDate:String): Observable<Array<PersoneOffDay_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/PersoneOff/GetOffday?token=" + Token
      + "&PeriodDate="+PeriodDate
      + "&status="+status
      + "&fullname="+fullname
      + "&StartSearchDate="+StartSearchDate
      + "&EndSearchDate="+EndSearchDate
    ).pipe(
      map(data => {
        return data as Array<PersoneOffDay_Interface>
      })
    )
  }

  AddOffday(startDate: String,
    endDate: String,
    dsc: String,
    replace_person_id: number,
    token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      startDate: startDate,
      endDate: endDate,
      dsc: dsc,
      replace_person_id: replace_person_id,
      token: token,
      id: 0
    }
    return this.http.post(environment.BaseUrl + "Daro/PersoneOff/AddOffday", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  CheckOffday(startDate: String,
    endDate: String,
    dsc: String,
    token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      startDate: startDate,
      endDate: endDate,
      dsc: dsc,
      token: token,
      id: 0
    }
    return this.http.post(environment.BaseUrl + "Daro/PersoneOff/CheckOffday", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  GetSingleOffday(Token: String,id:number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/PersoneOff/GetSingleOffday?token=" + Token
    + "&id="+id).pipe(
      map(data => {
        return data as any
      })
    )
  }



}
